import { c as _c } from "react/compiler-runtime";
import type { CustomRequirementContentPrompt, CustomRequirementPage } from '@onefootprint/request-types/dashboard';
type ReadOnlyFormProps = {
  page: CustomRequirementPage;
};
const ReadOnlyForm = t0 => {
  const $ = _c(12);
  const {
    page
  } = t0;
  let t1;
  if ($[0] !== page.header) {
    t1 = <div className="text-label-2 text-secondary">{page.header}</div>;
    $[0] = page.header;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== page.subheader) {
    t2 = <div className="text-body-2 text-tertiary">{page.subheader}</div>;
    $[2] = page.subheader;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-col gap-1">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== page.sections) {
    t4 = page.sections.length > 0 ? <ul className="flex flex-col gap-1 pl-4 list-disc">{page.sections.filter(_temp).map(_temp2)}</ul> : null;
    $[7] = page.sections;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex flex-col gap-2 p-4 rounded border border-dashed border-tertiary">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default ReadOnlyForm;
function _temp(section) {
  return section.kind === "prompt";
}
function _temp2(section_0) {
  return <li key={section_0.di}><div className="text-body-2 text-secondary">{section_0.prompt}</div></li>;
}